<script>
  import {_} from '../../translations';

  export let openText = _('button.collapseOpen');
  export let closeText = _('button.collapseClose');

  $: opened = false;

  const id = Math.random();
  const onToggle = event => {
    opened = event.target.checked;
  };
</script>

<div class="scmp_Collapse">
  <input on:change={onToggle} class="scmp_Collapse-input" type="checkbox" {id} data-dontobserve="true" />
  <div class="scmp_Collapse-text">
    <slot />
  </div>
  <label class="scmp_Collapse-label" for={id}>{opened ? closeText : openText}</label>
</div>
